"use strict";

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

function compose() {
  var funcs = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    funcs[_i] = arguments[_i];
  }

  var functions = funcs.reverse();
  return function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    var firstFunction = functions[0],
        restFunctions = functions.slice(1);
    var result = firstFunction.apply(null, args);
    restFunctions.forEach(function (fnc) {
      result = fnc.call(null, result);
    });
    return result;
  };
}

exports.compose = compose;